import * as Types from '../../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DeleteCandidatesMutationVariables = Types.Exact<{
  examId: Types.Scalars['ID'];
  ids: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;


export type DeleteCandidatesMutation = { __typename?: 'Mutation', destroyCandidates?: { __typename?: 'DestroyCandidatesPayload', jobId?: string | null, successful: boolean, error?: string | null } | null };

export const DeleteCandidatesDocument = gql`
    mutation DeleteCandidates($examId: ID!, $ids: [ID!]!) {
  destroyCandidates(examId: $examId, ids: $ids) {
    jobId
    successful
    error
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCandidatesGQL extends Apollo.Mutation<DeleteCandidatesMutation, DeleteCandidatesMutationVariables> {
    document = DeleteCandidatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }